<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="(this.Instruction.units ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="BMUs">
                <select njFormField id="BMUs" [(ngModel)]="Instruction.units" (ngModelChange)="BMU_Changed()" >
                    <option *ngFor="let unit of BMUList" value='{{unit}}'>{{unit}}</option>
                </select>
                <ng-container njFormLabel>Unit</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="(this.Instruction.issuedFrom ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedTo" />
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments">
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    @if (Instruction.units == "MOWWO-4") {
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="mw4Fixed" [isRequired]="true">
                <input id="mw4Fixed" type="number" [(ngModel)]="Instruction.fixed" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Monthly Fixed Elements</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="mw4RegoPrice" [isRequired]="true">
                <input id="mw4RegoPrice" type="number" [(ngModel)]="Instruction.regoPrice" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>REGO Price</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="mw4Percentage" [isRequired]="true">
                <input id="mw4Percentage" type="number" [(ngModel)]="Instruction.percentage" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Percentage</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    }
    @else {
    <!--dif-->
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="fixed" [isRequired]="true">
                <input id="fixed" type="number" [(ngModel)]="Instruction.fixed" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Monthly Fixed Elements</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="strikePrice" [isRequired]="true">
                <input id="strikePrice" type="number" [(ngModel)]="Instruction.strikePrice" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Strike Price</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="negativePriceTrigger" [isRequired]="true">
                <input id="negativePriceTrigger" type="number" [(ngModel)]="Instruction.negativePriceTrigger" njFormField min="0"
                    [disabled]="false" />
                <ng-container njFormLabel>Negative Price Trigger</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row title">
        Amazon 1 PPA
    </div>
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="amazon_commissioning" [isRequired]="true">
                <input id="amazon_commissioning" type="number" [(ngModel)]="Instruction.amazon_commissioning"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Commissioning Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="amazon_contracted" [isRequired]="true">
                <input id="amazon_contracted" type="number" [(ngModel)]="Instruction.amazon_contracted" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Contracted Electrical Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="amazon_commercial" [isRequired]="true">
                <input id="amazon_commercial" type="number" [(ngModel)]="Instruction.amazon_commercial" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Payment Element</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row title">
        Google PPA
    </div>
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="google_commissioning" [isRequired]="true">
                <input id="google_commissioning" type="number" [(ngModel)]="Instruction.google_commissioning"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Commissioning Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="google_contracted" [isRequired]="true">
                <input id="google_contracted" type="number" [(ngModel)]="Instruction.google_contracted" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Contracted Electrical Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="google_commercial_min" [isRequired]="true">
                <input id="google_commercial_min" type="number" [(ngModel)]="Instruction.google_commercial_min"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Minimum Payment Element</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="google_commercial_max" [isRequired]="true">
                <input id="google_commercial_max" type="number" [(ngModel)]="Instruction.google_commercial_max"
                    njFormField min="0" [disabled]="false" />
                <ng-container njFormLabel>Maximum Payment Element</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row title">
        Engie Nose 1 PPA
    </div>
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="engie_commissioning" [isRequired]="true">
                <input id="engie_commissioning" type="number" [(ngModel)]="Instruction.engie_commissioning" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Commissioning Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="engie_contracted" [isRequired]="true">
                <input id="engie_contracted" type="number" [(ngModel)]="Instruction.engie_contracted" njFormField
                    min="0" [disabled]="false" />
                <ng-container njFormLabel>Contracted Electrical Output</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    }
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>